import { isWorkingDay } from './holidays'

export function firstWorkingDayOfMonth(date: Date): Date {
  const candidate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
  while (!isWorkingDay(candidate)) {
    candidate.setDate(candidate.getDate() + 1)
  }
  return candidate
}

export function isFirstWorkingDayOfMonth(date: Date): boolean {
  const first = firstWorkingDayOfMonth(date)
  return (
    first.getDate() === date.getDate() &&
    first.getMonth() === date.getMonth() &&
    first.getFullYear() === date.getFullYear()
  )
}

export function isoWeekKey(date: Date): string {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  const dayNum = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum)
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  const weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86_400_000 + 1) / 7)
  return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`
}

export function monthKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
}
